<ng-container *ngIf="form">
  <div class="row">
    <div class="title-container">
      <span class="title">Incident ID: {{ form.get('incidentId').value !== 0 ? form.get('incidentId').value : 0 }}</span>
      <div class="status-chip" [ngClass]="form.get('status').value === 1 ? 'finalized' : 'draft'">
        <mat-icon>{{ form.get('status').value === 1 ? 'check_circle' : 'schedule' }}</mat-icon>
        <span class="chip" >{{ form.get('status').value === 1 ? 'Finalized' : 'Draft' }}</span>
      </div>
    </div>
  </div>
  <div class="row">
    <mat-form-field>
      <mat-label>Jumper Home Base</mat-label>
      <mat-select [formControl]="form.get('jumperBaseId')" (selectionChange)="onBaseChange($event)" >
        <mat-option *ngFor="let base of homeBasesDropdownList" [value]="base.id">
          {{ base.text }} {{ base.value ? '|' : ''}} {{ base.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Jumper</mat-label>
      <input
        type="text"
        aria-label="Jumper"
        matInput
        [formControl]="form.get('jumperDetails')"
        [matAutocomplete]="jumperAuto"
      />
      <mat-autocomplete
        #jumperAuto="matAutocomplete"
        (optionSelected)="onJumperSelection($event.option.value)"
        [displayWith]="jumpersDisplay"
      >
        <mat-option *ngFor="let jumper of filteredJumpers$ | async" [value]="jumper">
          {{ jumper.firstName }} {{ jumper.lastName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Position in Stick</mat-label>
      <mat-select [formControl]="form.get('positionInStick')">
        <mat-option [value]="null"></mat-option>
        <mat-option [value]="1"> 1 </mat-option>
        <mat-option [value]="2"> 2 </mat-option>
        <mat-option [value]="3"> 3 </mat-option>
        <mat-option [value]="4"> 4 </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field>
      <mat-label>Total Career Jumps To Date</mat-label>
      <input
        class="remove-arrows"
        matInput
        type="number"
        min="0"
        [value]="form.get('jumperDetails')?.value?.totalJumps || 0"
        disabled
        />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Total Jumps This Year To Date</mat-label>
      <input
      class="remove-arrows"
      matInput
      type="number"
      min="0"
      [value]="form.get('jumperDetails')?.value?.seasonJumps || 0"
      disabled
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Exit Weight</mat-label>
      <input
      class="remove-arrows"
      matInput
      type="number"
      min="0"
      [value]="form.get('jumperDetails')?.value?.weight || 0"
      disabled
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Days Since Last Jump</mat-label>
      <input
      class="remove-arrows"
      matInput
      type="number"
      min="0"
      [value]="form.get('jumperDetails').value?.daysSince || 0"
      disabled
      />
    </mat-form-field>
  </div>
  <mat-form-field color="primary" class="notes">
    <mat-label>Notes: included is any unassociated legacy information</mat-label>
    <textarea type="text" matInput [formControl]="form.get('jumperNotes')" rows="3"></textarea>
    <textarea type="text" matInput [formControl]="form.get('legacyData')" rows="5"></textarea>    
  </mat-form-field>
</ng-container>
